export { default as CollapsibleProductContainer } from "./CollapsibleProductContainer";
